module.exports = __webpack_public_path__ + "img/28.9f70bf52.png";